var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { postNoData } from "./api";
export const sendEmailForTransaction = (transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const { err, res: data } = yield to(postNoData(`/emails/send`, {
        transaction,
    }));
    if (err || !data)
        return false;
    return true;
});
